import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { ServiceMenu } from '@shared/layout/components/ServiceMenu';
import { Icon } from '@shared/ui/components/Icon';
import { cn } from '@shared/utils/helpers';

import { useShowMenu } from './useShowMenu';

type LayoutProps = {
  homeUrl: string;
  header: ReactNode;
  sidebar: ReactNode;
  main: ReactNode;
};

export function Layout({ homeUrl, header, sidebar, main }: LayoutProps) {
  const { showMenu, setShowMenu } = useShowMenu();

  return (
    <>
      <div
        data-show-menu={showMenu ? 'true' : 'false'}
        className="fixed lg:static top-0 left-0 w-screen z-layout-sidebar data-[show-menu=true]:bottom-0 flex flex-col lg:block"
      >
        <div
          data-show-menu={showMenu ? 'true' : 'false'}
          className={cn(
            'flex lg:hidden data-[show-menu=true]:flex justify-between',
            'px-8 lg:px-6 h-[70px] bg-[#282a3c] shadow-lg w-full lg:w-[250px]',
            'lg:fixed lg:top-0 lg:left-0 lg:z-layout-logotype'
          )}
        >
          <Link to={homeUrl}>
            <img src="/assets/app/media/img/logos/logo-alt.svg" alt="CAS" className="h-full" />
          </Link>
          <button className="self-center outline-none" onClick={() => setShowMenu(!showMenu)}>
            <Icon icon="bars" className="text-[#868aa8]" />
          </button>
        </div>
        <div
          data-show-menu={showMenu ? 'true' : 'false'}
          className={cn(
            'hidden lg:data-[show-menu=false]:flex items-center',
            'pl-8 h-[70px]',
            'lg:fixed lg:top-0 lg:left-0 lg:z-layout-logotype'
          )}
        >
          <button onClick={() => setShowMenu(true)}>
            <Icon icon="bars" className="text-gray-500" />
          </button>
        </div>

        <div
          data-show-menu={showMenu ? 'true' : 'false'}
          className={cn(
            'hidden data-[show-menu=true]:block lg:block',
            'lg:h-[70px] bg-[#9599b2] lg:bg-white shadow-lg',
            'lg:fixed lg:top-0 lg:left-0 lg:right-0 lg:z-layout-header',
            {
              'lg:pl-[250px]': showMenu,
              'lg:pl-[44px]': !showMenu,
            }
          )}
        >
          <div className="flex-1 flex items-center gap-3 lg:gap-6 px-6 lg:px-8 py-6 lg:py-4">
            {header}
            <ServiceMenu className="ml-auto flex-shrink-0" />
          </div>
        </div>

        <nav
          data-show-menu={showMenu ? 'true' : 'false'}
          className={cn(
            'hidden data-[show-menu=true]:block',
            'lg:fixed lg:top-0 lg:bottom-0 lg:z-layout-sidebar',
            'flex-1 w-full lg:w-[250px] min-h-0 lg:pt-[70px] bg-[#2c2e3e] text-indigo-200'
          )}
        >
          {sidebar}
        </nav>
      </div>

      <main className={cn('mt-[70px] px-8', { 'lg:ml-[250px]': showMenu })}>{main}</main>
    </>
  );
}
